import { useLayoutNames } from '@tunasong/plugin-lib'
import type { Entity, Persisted } from '@tunasong/schemas'
import { useCallback } from 'react'
import { useSearchParams } from 'react-router'

/** The current view is stored in the URL as search params */
export const useLayoutNavigation = ({
  entity,
  layoutNames,
  replaceHistory = false,
}: {
  entity?: Persisted<Entity>
  layoutNames?: string[]
  replaceHistory?: boolean
} = {}) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const entityLayoutNames = useLayoutNames(entity)
  const layouts = layoutNames ?? entityLayoutNames

  const currentLayoutParam = searchParams.get('layout')
  const currentLayout = currentLayoutParam && layouts.includes(currentLayoutParam) ? currentLayoutParam : layouts?.[0]

  const setLayout = useCallback(
    (layout: string) => {
      setSearchParams(
        params => ({
          ...Object.fromEntries(params.entries()),
          layout,
        }),
        {
          replace: replaceHistory,
        }
      )
    },
    [replaceHistory, setSearchParams]
  )

  return { currentLayout, setLayout }
}

export const useCurrentLayoutName = () => {
  const [searchParams] = useSearchParams()
  const layoutName = searchParams.get('layout') ?? undefined
  return layoutName
}
